/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Expiration_Date_HintInputs */

const en_admin_discounts_expiration_date_hint = /** @type {(inputs: Admin_Discounts_Expiration_Date_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last day the code can be redeemed`)
};

const de_admin_discounts_expiration_date_hint = /** @type {(inputs: Admin_Discounts_Expiration_Date_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzter Tag, an dem der Code eingelöst werden kann`)
};

const es_admin_discounts_expiration_date_hint = /** @type {(inputs: Admin_Discounts_Expiration_Date_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último día en que se puede canjear el código`)
};

const fr_admin_discounts_expiration_date_hint = /** @type {(inputs: Admin_Discounts_Expiration_Date_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernier jour pour utiliser le code`)
};

/** @type {(inputs: Admin_Discounts_Expiration_Date_HintInputs) => LocalizedString} */
const it_admin_discounts_expiration_date_hint = en_admin_discounts_expiration_date_hint;

/** @type {(inputs: Admin_Discounts_Expiration_Date_HintInputs) => LocalizedString} */
const pt_br2_admin_discounts_expiration_date_hint = en_admin_discounts_expiration_date_hint;

/** @type {(inputs: Admin_Discounts_Expiration_Date_HintInputs) => LocalizedString} */
const pl_admin_discounts_expiration_date_hint = en_admin_discounts_expiration_date_hint;

/** @type {(inputs: Admin_Discounts_Expiration_Date_HintInputs) => LocalizedString} */
const hu_admin_discounts_expiration_date_hint = en_admin_discounts_expiration_date_hint;

/** @type {(inputs: Admin_Discounts_Expiration_Date_HintInputs) => LocalizedString} */
const ro_admin_discounts_expiration_date_hint = en_admin_discounts_expiration_date_hint;

/**
* | output |
* | --- |
* | "Last day the code can be redeemed" |
*
* @param {Admin_Discounts_Expiration_Date_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_expiration_date_hint = /** @type {((inputs?: Admin_Discounts_Expiration_Date_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Expiration_Date_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_expiration_date_hint(inputs)
	if (locale === "de") return de_admin_discounts_expiration_date_hint(inputs)
	if (locale === "es") return es_admin_discounts_expiration_date_hint(inputs)
	if (locale === "fr") return fr_admin_discounts_expiration_date_hint(inputs)
	if (locale === "it") return it_admin_discounts_expiration_date_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_expiration_date_hint(inputs)
	if (locale === "pl") return pl_admin_discounts_expiration_date_hint(inputs)
	if (locale === "hu") return hu_admin_discounts_expiration_date_hint(inputs)
	return ro_admin_discounts_expiration_date_hint(inputs)
});
export { admin_discounts_expiration_date_hint as "admin.discounts.expiration_date_hint" }